import paronApi from '@/utils/paron-api'
export default {
    getAllTeams() {
        return paronApi.get('team/all')
    },

    // every team (team/all only returns the available ones), for dropdowns
    getTeamOptions() {
        return paronApi.post('team/filtered?page=1&per_page=2000', {})
    },

    getTeamById(id) {
        return paronApi.get(`team/${id}`)
    },

    createTeam(data) {
        return paronApi.post('team/new', data)
    },

    editTeamById(id, data) {
        return paronApi.post(`team/${id}/edit`, data)
    },

    deleteTeamById(id) {
        return paronApi.delete(`team/${id}`)
    },

    getTeamsByFilter(page, filter, sortOption, order, perPage = 10) {
        var path = `team/filtered?page=${page || 1}&per_page=${perPage}`
        if (sortOption) {
            path += `&sortOption=${sortOption}&order=${order || 'ASC'}`
        }
        return paronApi.post(path, filter)
    },

    toggleApproved(id) {
        return paronApi.post(`team/${id}/toggleApprove`)
    }

}
